import { Phone, ShieldCheck, Clock, BadgeCheck, Star } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLang } from "@/i18n/LanguageContext";
import { site } from "@/config/site";
import heroImg from "@/assets/hero-schluesseldienst-wien.jpg";

export const Hero = () => {
  const { t } = useLang();
  return (
    <section className="relative min-h-[92vh] flex items-center pt-16 overflow-hidden bg-gradient-hero">
      <div className="absolute inset-0">
        <img
          src={heroImg}
          alt="Schlüsseldienst Wien Techniker bei der Türöffnung"
          width={1600}
          height={1024}
          loading="eager"
          decoding="async"
          {...({ fetchpriority: "high" } as any)}
          className="w-full h-full object-cover opacity-35 md:opacity-55"
        />
        <div className="absolute inset-0 bg-gradient-overlay" />
      </div>

      <div className="container relative z-10 py-16">
        <div className="animate-fade-up max-w-3xl">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent-on-dark/15 border border-accent-on-dark/40 text-accent-on-dark mb-6">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-accent-on-dark opacity-75" />
              <span className="relative inline-flex rounded-full h-2 w-2 bg-accent-on-dark" />
            </span>
            <span className="text-xs font-semibold uppercase tracking-widest">{t("hero.badge")}</span>
          </div>

          <h1 className="font-display text-5xl md:text-7xl lg:text-8xl text-primary-foreground leading-[0.95] mb-6">
            {t("hero.title1")}<br />
            <span className="text-accent-on-dark">{t("hero.title2")}</span>
          </h1>

          <p className="text-lg md:text-xl text-primary-foreground/85 max-w-2xl mb-8">
            {t("hero.subtitle")}
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-10">
            <Button variant="emergency" size="xl" asChild>
              <a href={site.phoneHref} className="gap-3">
                <Phone className="!w-5 !h-5" /> {site.phoneDisplay}
              </a>
            </Button>
            <Button variant="outlineLight" size="xl" asChild>
              <a href="#leistungen">{t("nav.services")}</a>
            </Button>
          </div>

          <div className="flex flex-wrap gap-x-6 gap-y-3 text-primary-foreground/90">
            <div className="flex items-center gap-2"><ShieldCheck className="w-5 h-5 text-accent-on-dark" /><span className="text-sm font-medium">{t("hero.trust1")}</span></div>
            <div className="flex items-center gap-2"><Clock className="w-5 h-5 text-accent-on-dark" /><span className="text-sm font-medium">{t("hero.trust2")}</span></div>
            <div className="flex items-center gap-2"><BadgeCheck className="w-5 h-5 text-accent-on-dark" /><span className="text-sm font-medium">{t("hero.trust3")}</span></div>
            <div className="flex items-center gap-2"><Star className="w-5 h-5 text-accent-on-dark fill-accent-on-dark" /><span className="text-sm font-medium">{site.rating}★ ({site.reviewCount.toLocaleString("de-AT")})</span></div>
          </div>
        </div>
      </div>
    </section>
  );
};